const MOBILE_BP = 1199.98;
const COLLAPSED_KEY = 'sidebar-collapsed';

const rootEl = () => document.getElementById('root');

export function isMobileSidebar() {
  return window.innerWidth <= MOBILE_BP;
}

export function setSidebarOpen(open) {
  document.body.classList.toggle('sidebar-open', open);
}

export function setSidebarCollapsed(collapsed) {
  rootEl()?.classList.toggle('sidebar-collapsed', collapsed);
  try {
    localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function toggleSidebarOpen() {
  if (isMobileSidebar()) {
    setSidebarOpen(!document.body.classList.contains('sidebar-open'));
    return;
  }

  const root = rootEl();
  const collapsed = !root?.classList.contains('sidebar-collapsed');
  setSidebarCollapsed(collapsed);
  setSidebarOpen(false);
}

export function closeSidebar() {
  if (isMobileSidebar()) {
    setSidebarOpen(false);
    return;
  }
}

export function initSidebarState() {
  const root = rootEl();
  if (!root) return;

  if (isMobileSidebar()) {
    setSidebarOpen(false);
    return;
  }

  setSidebarOpen(false);
  let collapsed = false;
  try {
    collapsed = localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    collapsed = false;
  }
  setSidebarCollapsed(collapsed);
}

export function bindSidebarResize() {
  const onResize = () => {
    if (isMobileSidebar()) {
      rootEl()?.classList.remove('sidebar-collapsed');
      return;
    }
    setSidebarOpen(false);
    let collapsed = false;
    try {
      collapsed = localStorage.getItem(COLLAPSED_KEY) === '1';
    } catch {
      collapsed = false;
    }
    setSidebarCollapsed(collapsed);
  };

  window.addEventListener('resize', onResize);
  return () => window.removeEventListener('resize', onResize);
}
